import React from 'react';
import { StandaloneCheckbox } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';

const AcceptTermsAndConditions = ({
  isTermsChecked,
  onConfirmationCheckboxChange,
  isFormSubmit
}) => (
  <Content>
    {({ acceptTermsAndConditions = '', acceptTermsAndConditionsError = '', Yes = '' }) => (
      <Field name="acceptTermsAndConditions" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            inputId="acceptTermsAndConditions"
            validationMessage={!isTermsChecked && isFormSubmit ? acceptTermsAndConditionsError : ''}
          >
            <Field name="acceptTermsAndConditions" type="checkbox">
              {({ input }) => (
                <StandaloneCheckbox
                  id="acceptTC"
                  isChecked={isTermsChecked}
                  labelText={<b>{acceptTermsAndConditions}</b>}
                  onChange={({ isChecked }) => {
                    input.onChange(isChecked);
                    onConfirmationCheckboxChange(isChecked);
                  }}
                />
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default AcceptTermsAndConditions;
